import { useMemo } from "react";
import { RadioGroup } from "@headlessui/react";
import { t } from "@/i18n-js/instance";
import { Form } from "@circle-react-uikit/Form";
import { CreateTemplateField } from "./fields/CreateTemplateField";
import { UpdateTemplateField } from "./fields/UpdateTemplateField";

export const templateLocaleNamespace = "settings.emails.templates";

export const UpdateTemplateContent = ({
  templateName,
}: {
  templateName: string;
}) => {
  const displayFormatOptions = useMemo(
    () => [
      {
        label: t([templateLocaleNamespace, "save_changes_to_template"], {
          templateName,
        }),
        value: "updateTemplate",
      },
      {
        label: t([templateLocaleNamespace, "save_as_new_template"]),
        value: "createTemplate",
      },
    ],
    [templateName],
  );

  return (
    <div className="pb-3 pt-6">
      <Form.RadioGroup
        variant="radio"
        name="template_type"
        options={displayFormatOptions}
        verticalSpacing="high"
        renderOption={({ name, label, value }) => (
          <RadioGroup.Option key={value} value={value}>
            {({ checked }) => {
              if (value === "updateTemplate") {
                return (
                  <UpdateTemplateField
                    name={name}
                    label={label}
                    value={value}
                    checked={checked}
                  />
                );
              }
              return (
                <CreateTemplateField
                  name={name}
                  label={label}
                  value={value}
                  checked={checked}
                />
              );
            }}
          </RadioGroup.Option>
        )}
      />
    </div>
  );
};
